<div
  class="flex h-screen flex-col overflow-hidden pl-4 pr-4"
  style="
    background: url('/assets/images/bg-illustration.png') no-repeat;
    background-position: left bottom;
    background-size: 330px;
    background-color: #fbfbfb;
  "
>
  <app-global-header></app-global-header>
  <div class="flex-1 overflow-y-auto pb-16">
    <router-outlet></router-outlet>
  </div>

<div class="flex items-center gap-2 justify-center">
    <img src="/assets/images/svgs/sec-logo.svg" alt="" class="h-4 w-auto "/>
    <p class="font-light text-xs text-mango-gray74 text-center">Mango Asset Management is registered and regulated by the Securities and Exchange Commission, Nigeria</p>
  </div>

</div>
